import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import RegistOrLogin from './RegistOrLogin';
import { Box, Snackbar } from '@mui/material';

function getStyle(iconValue){
    const style = [
        {cursor:"pointer",color:"#333333"},
        {cursor:"pointer",color:"#000000"}
    ];
    if(iconValue){
        return style[0];
    } else {
        return style[1];
    }
}

const FavoriteIconV2 = (props) => {
    const {t,i18n} = useTranslation()
    const [iconValue,setState] = useState(false)
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [count,setCount] = useState(props.count || 0)
    const [first,setFirst] = useState(true)
    const [open,setOpen] = useState(false)
    const [favMessage,setFavMessage] = useState("")

    useEffect(() =>{
        setState(props.favorite)
    },[props.favorite,props.id])

    function changeStyle(b){
        console.log(loginInfo)
        if(loginInfo.length == 0 || !loginInfo.result){
            props.dialog("エラー","いいねするにはログインする必要があります。")
            return
        }
        if(b){
            new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/"+props.type+"/"+props.id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        setState(b)
                        if(json.data && json.data.message !== ""){
                            setOpen(true)
                            setFavMessage(json.data.message)
                        }
                    } else {
                        props.dialog("エラー",json.errors)
                        setOpen(false)
                    }
                })  
            })
        } else {
            new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/"+props.type+"/"+props.id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        setState(b);
                    } else {
                        props.dialog("エラー",json.errors)
                    }
                })  
            })
        }
    }

    useEffect(() => {
        let me = document.querySelector(".likeButton")
        let heart = document.querySelectorAll(".heart")
        if(iconValue){
            if(props.favorite && first){
                setFirst(false)
                heart.forEach(e => e.classList.add("goodFill"))
                return
            }
            me.classList.add("clicked")
            if(count !== -1) setCount(parseInt(count)-1)
        } else {
            me.classList.remove("clicked")
            heart.forEach(e => e.classList.remove("goodFill"))
            if(count !== -1) setCount(parseInt(count)+1)
        }
    },[iconValue])

    return (
        <span style={props.style}>
        <Snackbar
            anchorOrigin={{ vertical:"botom", horizontal:"left" }}
            open={open}
            onClose={() => setOpen(false)}
            message={favMessage}
            key={"bottomleft"}
        />
        <svg className={"likeButton m-0"} width="32px" height="32px" viewBox="0 0 500 500" onClick={(e) => {
                changeStyle(!iconValue)
            }}>
            <circle className="explosion" r="150" cx="250" cy="250"></circle>
            <g className="particleLayer">
                <circle fill="#8CE8C3" cx="130" cy="126.5" r="12.5"/>
                <circle fill="#8CE8C3" cx="411" cy="313.5" r="12.5"/>
                <circle fill="#91D2FA" cx="279" cy="86.5" r="12.5"/>
                <circle fill="#91D2FA" cx="155" cy="390.5" r="12.5"/>
                <circle fill="#CC8EF5" cx="89" cy="292.5" r="10.5"/>
                <circle fill="#9BDFBA" cx="414" cy="282.5" r="10.5"/>
                <circle fill="#9BDFBA" cx="115" cy="149.5" r="10.5"/>
                <circle fill="#9FC7FA" cx="250" cy="80.5" r="10.5"/>
                <circle fill="#9FC7FA" cx="78" cy="261.5" r="10.5"/>
                <circle fill="#96D8E9" cx="182" cy="402.5" r="10.5"/>
                <circle fill="#CC8EF5" cx="401.5" cy="166" r="13"/>
                <circle fill="#DB92D0" cx="379" cy="141.5" r="10.5"/>
                <circle fill="#DB92D0" cx="327" cy="397.5" r="10.5"/>
                <circle fill="#DD99B8" cx="296" cy="392.5" r="10.5"/>
            </g>
            <path className="heart" d="M484.5,327.114c16.188-6.984,27.5-23.047,27.5-41.781c0-19.25-11.969-35.625-28.859-42.297
                    c9.891-8.359,16.281-20.672,16.281-34.625c0-25.172-20.391-45.563-45.547-45.563H350.063c9.969-19.625,18.625-45.563,15.672-76.594
                    c-2.766-29.203-27.391-80.828-65.359-83.875c-29.25-2.344-34.906,8.625-34.906,37.969c0,0,0.328,28.422,0.328,46.641
                    c0,32.641-10.859,49.25-49.234,76.766c-50.625,36.297-59.406,55.031-59.406,55.031v216.672c0,27.219,22.063,49.281,49.281,49.281
                    h94.531h115.375c25.188,0,59.219-12.156,59.219-45.547c0-12.5-5.031-23.813-13.188-32.047
                    c22.031-3.188,39.016-21.969,39.016-44.891C501.391,348.021,494.734,335.474,484.5,327.114z"></path>
            <path className="heart" d="M96.703,202.849H24.625C11.031,202.849,0,213.864,0,227.489v257.813c0,13.594,11.031,24.625,24.625,24.625
                h72.078c13.609,0,24.641-11.031,24.641-24.625V227.489C121.344,213.864,110.313,202.849,96.703,202.849z M65.906,470.817
                c-12.594,0-22.813-10.219-22.813-22.813s10.219-22.813,22.813-22.813c12.625,0,22.813,10.219,22.813,22.813
                S78.531,470.817,65.906,470.817z"></path>
        </svg>
        <span style={{color:"#555555",display:count === 0 || count === -1 ? "none" : "inline"}}>{count}</span>
        </span>
    )
}

export default FavoriteIconV2;